/* eslint-disable no-unused-vars */

export enum TransactionType {
  P2P = 1,
  TED = 2,
  BILLET = 3,
  RECHARGE_BILLET = 4,
  DEPOSIT = 5,
  PIX = 6,
  CASHBACK = 7,
  RECHARGE_CELLPHONE = 8,
  TARIFF = 9,
  ATM_WITHDRAW = 10,
  ATM_DEPOSIT = 11,
  CREDIT = 12,
  DEBIT = 13,
  CARD_DEBIT = 14,
  BALANCE_BLOCK = 15,
  BALANCE_UNLOCK = 16,
  BILLET_PIX = 17,
  PAYMENT_LINK = 18,
  POINTS = 19,
  INVESTMENTS = 20,
  ACCOUNT_BALANCE = 21,
  TOTAL_AMOUNT = 22,
  PIX_WITHDRAW = 23,
  PIX_CHANGE = 24,
  QR_CODE = 25,
  MEMBER_GET_MEMBER_CASHBACK = 26,
  CARTAO_PRE_PAGO = 27,
  CANC_CARTAO_PRE_PAGO = 28,
  REVERSAL = 29,
  UNKNOWN = 100,
  P2P_TARIFF_CARD = 101,
  PAYMENT_OF_PROCEEDS = 201,
}

export const TransactionTypeArray = [
  { id: TransactionType.P2P, name: 'P2P' },
  { id: TransactionType.TED, name: 'TED' },
  { id: TransactionType.BILLET, name: 'Boleto' },
  { id: TransactionType.RECHARGE_BILLET, name: 'Boleto Recarga' },
  { id: TransactionType.DEPOSIT, name: 'Depósito' },
  { id: TransactionType.PIX, name: 'PIX' },
  { id: TransactionType.CASHBACK, name: 'Cashback' },
  { id: TransactionType.RECHARGE_CELLPHONE, name: 'Recarga Celular' },
  { id: TransactionType.TARIFF, name: 'Tarifa' },
  { id: TransactionType.ATM_WITHDRAW, name: 'Caixa eletrônico - saque' },
  { id: TransactionType.ATM_DEPOSIT, name: 'Caixa eletrônico - depositar' },
  { id: TransactionType.CREDIT, name: 'Crédito' },
  { id: TransactionType.DEBIT, name: 'Débito' },
  { id: TransactionType.CARD_DEBIT, name: 'Cartão débito' },
  { id: TransactionType.BALANCE_BLOCK, name: 'Saldo bloqueado' },
  { id: TransactionType.BALANCE_UNLOCK, name: 'Saldo desbloqueado' },
  { id: TransactionType.UNKNOWN, name: 'Desconhecido' },
  { id: TransactionType.CARTAO_PRE_PAGO, name: 'Compra Cartão' },
  { id: TransactionType.CANC_CARTAO_PRE_PAGO, name: 'Canc. Compra Cartão' },
  { id: TransactionType.BILLET_PIX, name: 'Pagamento de proventos' },
  { id: TransactionType.PAYMENT_LINK, name: 'Link de pagamento' },
  { id: TransactionType.POINTS, name: 'Pontos' },
  { id: TransactionType.INVESTMENTS, name: 'Investimentos' },
  { id: TransactionType.ACCOUNT_BALANCE, name: 'Saldo da conta' },
  { id: TransactionType.TOTAL_AMOUNT, name: 'Valor total' },
  { id: TransactionType.PIX_WITHDRAW, name: 'PIX - Saque' },
  { id: TransactionType.PIX_CHANGE, name: 'PIX - Troca' },
  { id: TransactionType.QR_CODE, name: 'QR Code' },
  {
    id: TransactionType.MEMBER_GET_MEMBER_CASHBACK,
    name: 'Member Get Member Cashback',
  },
  { id: TransactionType.P2P_TARIFF_CARD, name: 'Tarifa P2P Cartão' },
  { id: TransactionType.PAYMENT_OF_PROCEEDS, name: 'Pagamento de proventos' },
];

export const getTransactionName = (id?: number) => {
  return TransactionTypeArray.find((o) => o.id === Number(id))?.name;
};
